import React from 'react';
import '../../../styles/pages/Legal.css';

const PhotoRelease: React.FC = () => {
  return (
    <div className="legal-page-container">
      <div className="legal-card">
        <header className="legal-header">
          <h1>Parental Consent Form</h1>
          <p>Overture – Music × Games Program</p>
        </header>

        <section className="legal-section">
          <p>
            Dear Parent/Guardian, we are thrilled to have your child participate in our after-school program. As part of our curriculum, students engage in creative activities, including music composition and interactive sessions that may be photographed, audio recorded, or videotaped. To enhance our program and celebrate our students' achievements, we request your permission for the following.
          </p>
        </section>

        <section className="legal-section">
          <h2>What You Are Consenting To</h2>
          <ul>
            <li>Use of recordings (photos, video, and audio) of your child during program activities</li>
            <li>Use of your child’s original music compositions created during the program</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>How We May Use These Materials</h2>
          <ul>
            <li>Educational and instructional purposes</li>
            <li>Promotional content (brochures, flyers, social media, newsletters)</li>
            <li>Display on our official website and at showcase events</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>License and Permissions</h2>
          <p>
            By granting consent, you authorize Overture Inc. to use, reproduce, modify, and publicly display recordings of your child and their music compositions on a non-exclusive, royalty-free basis.
          </p>
        </section>

        <section className="legal-section">
          <h2>Privacy and Identifying Information</h2>
          <p>
            We respect your child’s privacy: we will never publish personal identifying information (such as last name) without additional written permission.
          </p>
        </section>

        <section className="legal-section">
          <h2>Duration and Revocation</h2>
          <p>
            This consent will remain valid for future program years unless you revoke it in writing. You understand that participation in the program is not dependent on granting this permission.
          </p>
        </section>

        <section className="legal-section">
          <h2>Compensation</h2>
          <p>
            You and your child will not receive compensation for the use of these materials.
          </p>
        </section>

        <section className="legal-section">
          <h2>Questions</h2>
          <p>
            If you have any questions about this consent form or our program, please contact us at <a href="mailto:info@overture.games">info@overture.games</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PhotoRelease;

